import __request__ from "routing/request";
export function update(body) {
  return __request__("PUT", "/system/indices/index_set_defaults", body, {}, {
    "Accept": ["application/json"]
  });
}
